import React from "react";
import { Link } from "react-router-dom";
import rootDir from "../..";

interface Props {
    songData: any;
}

const ArrTable = ({songData}: Props) => {
    return (
        <table id="arrangement-table" border={1}>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Type</th>
                    <th>Added</th>
                    <th>Charter</th>
                    {/* <th>Plays</th> */}
                    {/* <th>Metadata</th> */}
                    <th><img src={rootDir+"img/YT.png"} alt="YT"/></th>
                    <th>Note</th>
                </tr>
            </thead>
            <tbody>
                { songData.arrangements ? Object.keys(songData.arrangements).map((i,j) => ( 
                    Object.keys(songData.arrangements[i]).map((k,l) => (
                        <tr key={i+'-'+songData.arrangements[i][l].sequence+'-'+k}>
                            <td><img src={rootDir+"img/arr/"+i+".png"} alt={i} title={i} height={20} /></td>
                            <td title={i.replace('_', ' ')}>{songData.arrangements[i][l].sequence?'('+songData.arrangements[i][l].sequence+') ':null}{i.replace('_', ' ')} {songData.arrangements[i][l].verified ? <img src={rootDir+"img/verified.png"} height={20} alt="Verified" title="Arrangement is Verified" /> : null}</td>
                            <td>{new Date(songData.arrangements[i][l].created * 1000).toLocaleString()}</td>
                            <td>{ songData.arrangements[i][l].charter_ubi_id === "None" ? songData.arrangements[i][l].charter : <Link to={rootDir+'creator/'+songData.arrangements[i][l].charter_id}>{songData.arrangements[i][l].charter}</Link>}</td>
                            {/* <td className="arrPlays">{songData.arrangements[i][l].plays}</td> */}
                            {/* <td>Insert Metadata Here</td> */}
                            <td>{songData.arrangements[i][l].video.web ? <img src={rootDir+"img/YT.png"} alt="Playthrough Video" /> : null}</td>
                            <td>{songData.arrangements[i][l].note ? songData.arrangements[i][l].note : null}</td>
                        </tr>
                    )) )) : null }
            </tbody>
        </table>
    )
}

export default ArrTable